import { Component, OnInit, Input } from '@angular/core';
import { Bounty } from '../../../interfaces/Bounty';
import { BountyService } from '../../../services/bounty.service';
import { Router } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import {
  STATUS_COLORS,
  getBeatmapLink
} from '../view-bounty/view-bounty.component';

@Component({
  selector: 'app-bounty-card',
  templateUrl: './bounty-card.component.html',
  styleUrls: ['./bounty-card.component.scss'],
})
export class BountyCardComponent implements OnInit {
  @Input()
  bounty: Bounty;
  @Input()
  isListing: boolean;
  @Input() fillHeight = true;

  public user: any;
  public statusColors = STATUS_COLORS;

  constructor(
    private bountyService: BountyService,
    private router: Router,
    userService: UserService,
  ) {
    this.user = userService.getUser();
  }

  ngOnInit() {}

  get title() {
    return this.bountyService.getBountyTitle(this.bounty);
  }

  get endedWithNoWinner() {
    return this.bounty.completed_at && !this.bounty.winning_claim;
  }

  get labelClass() {
    return this.bountyService.getBountyLabelClass(this.bounty);
  }

  public getCardStyles(type: Bounty['type']) {
    switch (type) {
      case 'beatmap':
        return {
          background: `linear-gradient( rgba(0, 0, 0, 0.6),
            rgba(0, 0, 0, 0.7) ),
            url(https://assets.ppy.sh/beatmaps/${
              this.bounty.beatmapset_id
            }/covers/card@2x.jpg)`,
          'background-position': 'center',
          'background-size': 'cover',
          'background-repeat': 'no-repeat',
        };
    }
  }

  public getModsString(bounty: Bounty) {
    return bounty.mods.join(', ');
  }

  public getBeatmapHref() {
    return getBeatmapLink(this.bounty);
  }

  public onBeatmapHrefClicked(event) {
    event.stopPropagation();
  }

  public viewBounty() {
    this.router.navigate([`/bounties/${this.bounty.id}`]);
  }

  public async likeBounty(event) {
    event.stopPropagation();
    event.preventDefault();

    if (!this.user) {
      return;
    }

    await this.bountyService.likeBounty(this.bounty);
    this.bounty.userHasLiked = !this.bounty.userHasLiked;
    const change = this.bounty.userHasLiked ? 1 : -1;
    this.bounty.likes = Math.max(0, this.bounty.likes + change);
  }
}
